import React from 'react';
import { SearchIcon } from 'lucide-react';
interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  label?: string;
  className?: string;
}
export function SearchInput({
  value,
  onChange,
  placeholder = 'Search name or extension...',
  label = 'Search users',
  className = 'sm:w-72'
}: SearchInputProps) {
  return <label className={`relative block w-full ${className}`} data-id="element-134" data-mp="3rw4bj6wnze37">
      <span className="sr-only" data-id="element-135" data-mp="3rwe6l8wkgbfr">{label}</span>
      <SearchIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-subtle" aria-hidden data-id="element-136" data-mp="3nuson956d6yp" />
      <input type="search" value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} className="w-full rounded-xl border border-line bg-surface py-2 pl-9 pr-3 text-[13px] text-ink shadow-card placeholder:text-subtle focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/15" data-id="element-137" data-mp="5pxomu53avyx" />
    </label>;
}